import { inject, NgModule } from "@angular/core";
import { AuthorizationTokenHeaderInterceptor } from "src/app/interceptors/authorization-token-header.interceptor";
import { MemberTokenHeaderInterceptor } from "src/app/interceptors/member-token-header.interceptor";
import { RoleInterceptor } from "src/app/interceptors/role.interceptor";
import { CacheInterceptor } from "src/app/interceptors/cache.interceptor";
import { PreventUndefinedInterceptor } from "src/app/interceptors/prevent-undefined.interceptor";
import { ForbiddenInterceptor } from "src/app/interceptors/forbidden.interceptor";
import { Sentry400Interceptor } from "src/app/interceptors/sentry-400.interceptor";
import { Sentry409Interceptor } from "src/app/interceptors/sentry-409.interceptor";
import { SentryContextInterceptor } from "src/app/interceptors/sentry-context.interceptor";
import { InterceptorManagerService } from "src/app/interceptors/interceptor-manager.service";
import { TimeoutInterceptor } from "src/app/interceptors/timeout.interceptor";
import { MongoIdInterceptor } from "src/app/interceptors/mongo-id.intercetor";
import { PRODUCT_TOKEN } from "src/app/core/product.token";
import { SoftwareProduct } from "src/app/support/product";
import { CorrelationHeaderInterceptor } from "src/app/interceptors/correlation-header.interceptor";

@NgModule({
  imports: [],
  providers: [
    InterceptorManagerService,
    SentryContextInterceptor,
    Sentry400Interceptor,
    Sentry409Interceptor,
    CorrelationHeaderInterceptor,
    ForbiddenInterceptor,
    PreventUndefinedInterceptor,
    MongoIdInterceptor,
    TimeoutInterceptor,
    AuthorizationTokenHeaderInterceptor,
    MemberTokenHeaderInterceptor,
    RoleInterceptor,
    CacheInterceptor
  ]
})
export class InterceptorsModule {
  readonly #interceptorManager = inject(InterceptorManagerService);

  constructor() {
    this.#interceptorManager.addInterceptor(
      "correlation-header",
      inject(CorrelationHeaderInterceptor)
    );
    this.#interceptorManager.addInterceptor(
      "sentry-context",
      inject(SentryContextInterceptor)
    );
    this.#interceptorManager.addInterceptor(
      "sentry-400",
      inject(Sentry400Interceptor)
    );
    this.#interceptorManager.addInterceptor(
      "sentry-409",
      inject(Sentry409Interceptor)
    );
    this.#interceptorManager.addInterceptor(
      "forbidden",
      inject(ForbiddenInterceptor)
    );
    this.#interceptorManager.addInterceptor(
      "prevent-undefined",
      inject(PreventUndefinedInterceptor)
    );
    this.#interceptorManager.addInterceptor(
      "mongo-id",
      inject(MongoIdInterceptor)
    );
    this.#interceptorManager.addInterceptor(
      "timeout",
      inject(TimeoutInterceptor)
    );
    this.#interceptorManager.addInterceptor("role", inject(RoleInterceptor));
    this.#interceptorManager.addInterceptor("cache", inject(CacheInterceptor));

    /* TODO spostare queste due registrazioni in snoots.module quando
     * il refactoring di snoots domain è completo
     */
    if (inject(PRODUCT_TOKEN) != SoftwareProduct.BOTMASTER) {
      this.#interceptorManager.addInterceptor(
        "authorization-token-header",
        inject(AuthorizationTokenHeaderInterceptor)
      );
      this.#interceptorManager.addInterceptor(
        "member-token-header",
        inject(MemberTokenHeaderInterceptor)
      );
    }
  }
}
